import { plural } from '@westhetics/ui'
import type { Practitioner, PractitionerUsage } from './api'

/** O código da linha "Sem conselho profissional" da tabela conselho × profissão (RN-ADM-21). */
export const NO_COUNCIL = 'NO_COUNCIL'

/** O conselho como a tela mostra: a sigla ("CRM"); para quem não tem conselho, o nome por extenso. */
export function councilLabel(council: { code: string; name: string }) {
  return council.code === NO_COUNCIL ? council.name : council.code
}

/** A profissão por extenso, com a especialidade depois dela quando existe (RN-ADM-24). */
export function professionLabel(practitioner: Pick<Practitioner, 'professionName' | 'specialty'>) {
  return practitioner.specialty
    ? `${practitioner.professionName} · ${practitioner.specialty}`
    : practitioner.professionName
}

/** O registro como a pessoa digita: maiúsculas, sem espaço nas pontas nem espaço dobrado. */
export function normalizeRegistration(text: string) {
  return text.trim().replace(/\s+/g, ' ').toUpperCase()
}

/** "região número[-sufixo]", como "SP 897886" ou "3 123456-F" (RN-ADM-21). */
export const REGISTRATION_PATTERN = /^[A-Z0-9]{1,3} [0-9]{3,7}(-[A-Z]{1,3})?$/

/**
 * O efeito real de arquivar, com os números do uso (RN-ADM-23). Sem os números (ainda carregando,
 * ou a contagem falhou), a frase continua verdadeira sem eles.
 */
export function archiveEffect(
  usage: Pick<PractitionerUsage, 'contractCount' | 'treatmentPlanCount'> | undefined,
) {
  const lead = 'Ela sai da lista de profissionais e não pode ser escolhida em novos documentos.'
  const tail = 'Volta a qualquer momento.'
  if (!usage) {
    return `${lead} Planos e contratos em nome dela continuam intactos; nada assinado se desfaz. ${tail}`
  }
  const total = usage.treatmentPlanCount + usage.contractCount
  if (total === 0) return `${lead} Nenhum plano ou contrato está em nome dela. ${tail}`
  if (total === 1) {
    const what = usage.treatmentPlanCount === 1 ? 'plano' : 'contrato'
    return `${lead} O ${what} em nome dela continua intacto; nada assinado se desfaz. ${tail}`
  }
  const kept = [
    usage.treatmentPlanCount > 0 ? plural(usage.treatmentPlanCount, 'plano') : null,
    usage.contractCount > 0 ? plural(usage.contractCount, 'contrato') : null,
  ]
    .filter(Boolean)
    .join(' e ')
  return `${lead} Os ${kept} em nome dela continuam intactos; nada assinado se desfaz. ${tail}`
}
